import { AppBar, Autocomplete, Box, Button, CircularProgress, Divider, FormControlLabel, IconButton, styled, Switch, TextField, Toolbar, Tooltip, Typography } from '@mui/material';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import CloseIcon from '@mui/icons-material/Close';
// import AddCircleIcon from '@mui/icons-material/AddCircle';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import TuneIcon from '@mui/icons-material/Tune';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedProfileSimulate, setSelectedProfileSimulate } from '../../../redux/selectedProfileSimulateSlice';
import { getSelectedStatement, setSelectedStatement } from '../../../redux/selectedStatementSlice';
import DataGridSimulate from './components/DataGridSimulate';
import { useEffect, useMemo, useState } from 'react';
import { getStatementOptions, setStatementOptions } from '../../../redux/statementOptionsSlice';
import { getUsedParametersInDiagram, setUsedParametersInDiagram } from '../../../redux/usedParametersInDiagramSlice';
import { getRegulatoryFile } from '../../../redux/regulatoryFileSlice';
import CustomProfilesSimulator from './components/CustomProfilesSimulator';
import { getSimulatorProfiles, setSimulatorProfiles } from '../../../redux/simulatorProfilesSlice';
import findSubjectAttrToSimulator from '../../../utils/findSubjectAttrToSimulator';
import { setSnackbarMessage } from '../../../redux/snackbarMessageSlice';
import UserProfileManagement from './components/UserProfileManagement';
import sortedProfilesAttributes from '../../../utils/sortedProfilesAttributes';
import { v4 as uuidv4 } from 'uuid';
import { getSubjectSchema } from '../../../redux/subjectSchemaSlice';
import { dataTypes } from '../../../utils/configDataTypes';
import ConfirmDialogReuse from '../ReuseComponents/ConfirmDialogReuse';
import { LoadingButton } from '@mui/lab';
import { setStatementHighlightPaths } from '../../../redux/statementHighlightPathsSlice';
import { getIAAM } from '../../../redux/iaamSlice';

const DRGSimulatorPanel = (props) => {
    const { closePanel, nodes } = props;
    const dispatch = useDispatch();

    const profileSimulate = useSelector(getSelectedProfileSimulate);
    const selectedProfileSimulate = useSelector(getSelectedProfileSimulate);
    const regulatoryFile = useSelector(getRegulatoryFile)
    const statementOptions = useSelector(getStatementOptions);
    const usedParametersInDiagram = useSelector(getUsedParametersInDiagram);
    const simulatorProfiles = useSelector(getSimulatorProfiles);
    const subjectSchema = useSelector(getSubjectSchema);
    const selectedStatement = useSelector(getSelectedStatement);
    const iaam = useSelector(getIAAM);

    const [hasActiveParameter, setHasActiveParameter] = useState(false);
    const [selectedStatementData, setSelectedStatementData] = useState(null);
    const [options, setOptions] = useState([]);
    const [parameters, setParameters] = useState([]);
    const [profiles, setProfiles] = useState([]);
    const [isProfileChanged, setIsProfileChanged] = useState(false);
    const [project, setProject] = useState();
    const [openManagement, setOpenManagement] = useState(false);
    const [selectedEditProfile, setSelectedEditProfile] = useState(null);
    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
    const [selectedDeleteProfile, setSelectedDeleteProfile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isLoadingTable, setIsLoadingTable] = useState(false);
    const [dataSourceSimulate, setDataSourceSimulate] = useState(null);
    const [parameterHasError, serParameterHasError] = useState(false);

    const hasSelectedProfile = Boolean(
        selectedProfileSimulate?.id && simulatorProfiles.some(profile => profile.id === selectedProfileSimulate.id)
    );
    const canRunSimulation = hasSelectedProfile && !isProfileChanged && !parameterHasError && !isLoadingTable;

    useEffect(() => {
        const project = JSON.parse(localStorage.getItem('project'));
        if (project) {
            setProject(project);
        }
    }, []);

    useEffect(() => {
        if (usedParametersInDiagram) {
            const parameter_value = JSON.parse(localStorage.getItem('parameter-in-diagrams')) || {};
            setParameters(parameter_value);
            const hasError = usedParametersInDiagram.some(param => param.required && param.value === "");
            serParameterHasError(hasError);
        }
    }, [usedParametersInDiagram]);

    useEffect(() => {
        if (statementOptions.length > 1) {
            // console.log("statementOptions:", statementOptions)
            const addAllOption = ["All", ...statementOptions];
            setOptions(addAllOption);
            setSelectedStatementData("All")
            dispatch(setSelectedStatement("All"))
        } else {
            setOptions([]);
            setSelectedStatementData(null);
        }
    }, [statementOptions])

    useEffect(() => {
        const selectedProfileId = selectedProfileSimulate?.id;

        if (!selectedProfileId) {
            setSelectedStatementData(null);
            dispatch(setSelectedStatement(null));
            setOptions([]);
            dispatch(setStatementOptions([]));
            setDataSourceSimulate(null);
            dispatch(setStatementHighlightPaths([]));
            dispatch(setUsedParametersInDiagram([]));
            return;
        }

        const isSelectedProfileAvailable = simulatorProfiles.some(profile => profile.id === selectedProfileId);
        if (!isSelectedProfileAvailable) {
            dispatch(setSelectedProfileSimulate(null));
            setSelectedStatementData(null);
            dispatch(setSelectedStatement(null));
            setOptions([]);
            dispatch(setStatementOptions([]));
            setDataSourceSimulate(null);
            dispatch(setStatementHighlightPaths([]));
            dispatch(setUsedParametersInDiagram([]));
        }
    }, [selectedProfileSimulate, simulatorProfiles, dispatch])

    const handleSelectedStatement = (event, newValue) => {
        // console.log("statement: ", newValue);
        setSelectedStatementData(newValue);
        dispatch(setSelectedStatement(newValue));
    };

    const handleChangeParameterLocalStorage = (value, name) => {
        const new_obj = {
            ...parameters,
            [`${regulatoryFile.regulatory_diagram_id}-${name}`]: value
        }
        setParameters(new_obj)
        localStorage.setItem('parameter-in-diagrams', JSON.stringify(new_obj));
        const parameters_value = usedParametersInDiagram.map((item) => {
            if (item.name === name) {
                return {
                    ...item,
                    value: value
                }
            }
            return item;
        });
        dispatch(setUsedParametersInDiagram(parameters_value));
    };

    // const handleSetIntoLocalStorage = () => {
    //     console.log("parameters:", parameters)
    //     localStorage.setItem('parameter-in-diagrams', JSON.stringify(parameters));
    // };

    useEffect(() => {
        if (simulatorProfiles && simulatorProfiles.length > 0) {
            // console.log("simulatorProfiles", simulatorProfiles);
            const usedSubjectAttributes = findSubjectAttrToSimulator(nodes);
            const profilesData = simulatorProfiles.map(profile => {
                let attributes = {};
                Object.keys(usedSubjectAttributes).forEach(key => {
                    attributes[key] = profile?.attributes[key] || null;
                });
                return {
                    ...profile,
                    attributes: attributes,
                };
            });
            // console.log("profilesData", profilesData);
            setProfiles(profilesData);
            return;
        }

        setProfiles([]);
    }, [simulatorProfiles, nodes]);

    const onProfileChanged = (value) => {
        setIsProfileChanged(value)
    };

    const onSelectedProfile = async (profile) => {

        dispatch(setStatementHighlightPaths([]));
        dispatch(setSelectedStatement('All'));
        setDataSourceSimulate(null);
        dispatch(setStatementOptions([]));

        return;

        // try {
        //     const response = await fetch(`${process.env.REACT_APP_API_G2D}/getpath`, {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //         },
        //         body: JSON.stringify({
        //             drg_id: regulatoryFile?.regulatory_diagram_id || '',
        //             subject: profile?.attributes || {},
        //         })
        //     })
        //     if (response.ok) {
        //         const result = await response.json();
        //         const parameters = handleFindParameters(result);

        //         let normalized_parameters = {};
        //         if (parameters.length > 0) {
        //             for (const param of parameters) {
        //                 if (param.value) {
        //                     normalized_parameters[param.name] = param.value;
        //                 }
        //             }
        //         }

        //         const accessToken = await iaam.getAccessToken();
        //         const issuer = nodes.find(node => node.type === 'root').data.general_properties.dpe.issuer || '';

        //         const response1 = await fetch(`${issuer}/simulate/simulate_data`, {
        //             method: 'POST',
        //             headers: {
        //                 'Content-Type': 'application/json',
        //                 'Authorization': `Bearer ${accessToken}`
        //             },
        //             body: JSON.stringify({
        //                 drg_id: regulatoryFile?.regulatory_diagram_id || '',
        //                 params: normalized_parameters,
        //                 subject: profile?.attributes || {},
        //                 traverse: true,
        //                 dpe_url: issuer
        //             })
        //         })
        //         if (response1.ok) {
        //             const result1 = await response1.json();
        //             if (result1.schema) {
        //                 dispatch(setStatementHighlightPaths(result1.schema));
        //                 dispatch(setSelectedStatement('All'));
        //                 dispatch(setDataSourceSimulate(null));
        //                 dispatch(setStatementOptions([]));
        //             }
        //         } else if (response1.status === 403) {
        //             dispatch(setStatementHighlightPaths([]));
        //             dispatch(setSelectedStatement('All'));
        //             dispatch(setDataSourceSimulate(null));
        //             dispatch(setStatementOptions([]));
        //             throw new Error('Access denied for this user profile.');
        //         } else {
        //             throw new Error('Failed to highlight path diagram');
        //         }

        //         // dispatch(setSelectedStatement('All'));
        //         // dispatch(setDataSourceSimulate(null));
        //         // dispatch(setStatementOptions([]));
        //     } else {
        //         throw new Error('Failed to get path');
        //     }
        // } catch (error) {
        //     console.error("Error: ", error.message);
        //     dispatch(setStatementHighlightPaths([]));
        //     dispatch(setSelectedStatement('All'));
        //     dispatch(setDataSourceSimulate(null));
        //     dispatch(setStatementOptions([]));
        //     dispatch(setSnackbarMessage({
        //         open: true,
        //         message: error.message,
        //         status: 'error'
        //     }));
        // }
    }

    const handleFindParameters = (result) => {

        let hasParameters = {};
        for (const path of result) {
            for (const nodeId of path.nodes) {
                const node = nodes.find(nd => nd.id === nodeId);
                if (node.type === 'condition' && !hasParameters[node.id]) {
                    hasParameters[node.id] = [...node?.data?.general_properties?.conditions];
                }
            }
        }
        const used_parameters = hasParameterInCondition(hasParameters);
        // console.log("parameters:", used_parameters)

        const parameter_value = JSON.parse(localStorage.getItem('parameter-in-diagrams'));

        if (!parameter_value) {
            localStorage.setItem('parameter-in-diagrams', JSON.stringify({}));
        }

        const usedParameters = used_parameters
            .map((item) => {
                return {
                    name: item.name,
                    value: parameter_value[`${regulatoryFile.regulatory_diagram_id}-${item.name}`] ?? "",
                    required: item.required
                };
            })
            .sort((a, b) => {
                if (a.required && !b.required) return -1;
                if (!a.required && b.required) return 1;

                return a.name.localeCompare(b.name);
            });

        // console.log("usedParameters:", usedParameters)

        dispatch(setUsedParametersInDiagram(usedParameters))

        return usedParameters;

    };

    const hasParameterInCondition = (conditionNodes) => {
        const parameterMap = {};

        Object.keys(conditionNodes).forEach(key => {
            const conditions = conditionNodes[key] || [];

            for (const cond of conditions) {
                const subConds = cond?.subConditions || [];

                for (const subCond of subConds) {
                    const prop = subCond?.value_property;

                    if (prop?.value_type === 'Parameter') {
                        const name = prop.value;
                        const isRequired = !!prop.required;

                        const existing = parameterMap[name];

                        if (!existing || (!existing.required && isRequired)) {
                            parameterMap[name] = {
                                name: name,
                                required: isRequired
                            };
                        }
                    }
                }
            }
        });

        return Object.values(parameterMap);
    };

    const onSaveProfile = async (profile) => {
        try {
            const profiles = simulatorProfiles.map(pf => {
                if (pf.id === profile.id) {
                    const updatedAttr = { ...pf.attributes, ...profile.attributes };
                    const updatedProfile = {
                        ...pf,
                        name: profile.name,
                        attributes: updatedAttr,
                        updated_at: profile.updated_at
                    }
                    // dispatch(setSelectedProfileSimulate(updatedProfile));
                    onSelectedProfile(updatedProfile);
                    return updatedProfile
                }
                return pf;
            });
            // console.log("profiles:", profiles)
            const response = await fetch(`${process.env.REACT_APP_API_SIM_URL}/projects/${project?.project_id}/profiles`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    profiles: profiles
                })
            })
            if (response.ok) {
                // console.log("saved profile.", response)
                dispatch(setSimulatorProfiles(sortedProfilesAttributes(profiles)));
            } else {
                throw response;
            }
        } catch (error) {
            console.error("Error save profile: ", error);
            dispatch(setSnackbarMessage({ message: 'Failed to saved profile.', status: 'error' }));
        }
    };

    const memoizedAttributes = useMemo(() => {
        return findSubjectAttrToSimulator(nodes);
    }, [nodes]);

    const createNewProfileName = () => {
        const hasUnnamed = simulatorProfiles.some(profile => profile.name === "unname");
        if (!hasUnnamed) {
            return "unname";
        }

        let counter = 1;
        let newName = `unname-${counter}`;

        while (simulatorProfiles.some(profile => profile.name === newName)) {
            counter++;
            newName = `unname-${counter}`;
        }

        return newName;
    };

    const onAddNewProfile = async () => {
        let usedAttributes = {};
        for (const attr of subjectSchema) {
            const is_type = dataTypes.find(dt => dt.similar_type.includes(attr.attributeType));
            if (is_type.type === 'boolean') {
                usedAttributes[attr.name] = false;
            } else if (is_type.type === 'array') {
                usedAttributes[attr.name] = [];
            } else {
                usedAttributes[attr.name] = null;
            }
        }

        const newProfile = {
            id: uuidv4(),
            name: createNewProfileName(),
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            attributes: usedAttributes,
        };

        await handleAddProfile(newProfile);
    };

    const createCloneProfileName = (originalName) => {
        let counter = 1;
        let newName = `${originalName}-copy${counter}`;

        while (simulatorProfiles.some(profile => profile.name === newName)) {
            counter++;
            newName = `${originalName}-copy${counter}`;
        }

        return newName;
    };

    const onCloneProfile = async (profile) => {
        const attributes = simulatorProfiles.find(pf => pf.id === profile.id).attributes || {};

        const newProfile = {
            id: uuidv4(),
            name: createCloneProfileName(profile.name),
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            attributes: attributes,
        };

        await handleAddProfile(newProfile);
    };

    const handleAddProfile = async (newProfile) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_SIM_URL}/projects/${project?.project_id}/profiles`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(newProfile)
            });

            if (response.ok) {
                const result = await response.json();
                const updatedProfiles = [...simulatorProfiles, newProfile];
                dispatch(setSimulatorProfiles(sortedProfilesAttributes(updatedProfiles) || []));
                setSelectedEditProfile(newProfile);
                return;
            } else {
                throw new Error("Failed to add simulator profile");
            }
        } catch (error) {
            console.error(error.message);
            dispatch(setSnackbarMessage({
                open: true,
                message: error.message,
                status: "error",
            }));
        }
    };

    const handleEditProfile = (profile) => {
        const selectedProfile = simulatorProfiles.find(pf => pf.id === profile.id);
        setSelectedEditProfile(selectedProfile);
        setOpenManagement(true);
    };

    const handleDeleteProfile = (profile) => {
        setSelectedDeleteProfile(profile);
        setOpenDeleteConfirm(true);
    };

    const onDeleteClose = () => {
        setOpenDeleteConfirm(false);
        setLoading(false);
    };

    const handleDelete = async () => {
        try {
            setLoading(true);
            let options = {
                method: 'DELETE',
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify({
                    profile_ids: [selectedDeleteProfile.id]
                })
            }
            const response = await fetch(`${process.env.REACT_APP_API_SIM_URL}/projects/${project?.project_id}/profiles`, options);
            if (response.ok) {
                const updatedProfiles = simulatorProfiles.filter(profile => profile.id !== selectedDeleteProfile.id);
                const notHaveSelected = !updatedProfiles.find(profile => profile.id === selectedProfileSimulate?.id);
                if (notHaveSelected) {
                    dispatch(setSelectedProfileSimulate(null));
                }
                dispatch(setSimulatorProfiles(updatedProfiles.length > 0 ? updatedProfiles : []));
                setLoading(false);
                setOpenDeleteConfirm(false);
            } else {
                throw response;
            }
        } catch (error) {
            setLoading(false);
            setOpenDeleteConfirm(false);
            console.error("Error save profile: ", error);
            dispatch(setSnackbarMessage({ message: 'Failed to saved profile.', status: 'error' }));
        }

    };

    const handleOpenProfileManagement = () => {
        setSelectedEditProfile(null);
        setOpenManagement(true);
    };

    const runSimulateData = async () => {
        try {
            if (isLoadingTable) {
                return;
            }

            setIsLoadingTable(true);
            const accessToken = await iaam.getAccessToken();
            const issuer = nodes.find(node => node.type === 'root')?.data?.general_properties?.dpe?.issuer || '';

            let simulationParameters = {};
            if (usedParametersInDiagram.length > 0) {
                const parameterValue = JSON.parse(localStorage.getItem('parameter-in-diagrams')) || {};
                for (const param of usedParametersInDiagram) {
                    const value = parameterValue[`${regulatoryFile.regulatory_diagram_id}-${param.name}`];
                    if (value && value !== '') {
                        simulationParameters[param.name] = value;
                    }
                }
            }

            const selectedProfile = simulatorProfiles.find(profile => profile.id === profileSimulate?.id);

            const isPrimaryKey = nodes.find(node => node.type === 'root')?.data?.general_properties?.primary_key || [];

            const response = await fetch(`${issuer}/simulate/simulate_data`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    drg_id: regulatoryFile?.regulatory_diagram_id || '',
                    params: simulationParameters,
                    subject: selectedProfile?.attributes || {},
                    traverse: true,
                    dpe_url: issuer,
                    primary_key: isPrimaryKey
                })
            });

            if (response.ok) {
                const result = await response.json();
                const executeTime = response.headers.get('x-execute-time');
                // console.log('Simulation result:', { ...result, execute_time: executeTime });
                setDataSourceSimulate({ ...result, execute_time: executeTime });

                if (result.schema) {
                    const statementList = result.schema.map(item => item.statement) || [];
                    dispatch(setStatementOptions(statementList));
                    dispatch(setStatementHighlightPaths(result.schema));
                }

                setIsLoadingTable(false);
            } else if (response.status === 403) {
                setDataSourceSimulate({ data: [] });
                dispatch(setStatementOptions([]));
                setIsLoadingTable(false);
            } else {
                throw response;
            }
        } catch (error) {
            setIsLoadingTable(false);
            console.error('Error running simulation: ', error);
            dispatch(setSnackbarMessage({ message: 'Failed to run simulation', status: 'error' }));
        }
    };

    return (
        <>
            <Panel direction="vertical" defaultSize={50}>
                <PanelGroup direction="horizontal" id="simulator-panel-group">
                    <Panel id="profile-panel" order={1} defaultSize={18} minSize={15} className="flex flex-col min-w-0">
                        <AppBar position="static" sx={{ height: "30px", boxShadow: 'none', backgroundColor: "whitesmoke" }}>
                            <Toolbar disableGutters variant="dense" sx={{ minHeight: '30px', height: '30px', marginLeft: '12px', marginRight: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant='inherit' color='textSecondary'>User Profile</Typography>
                                <Tooltip title="Profile Management" arrow>
                                    <TuneIcon className='text-gray-400 p-0.5 hover:text-blue-600 cursor-pointer' onClick={handleOpenProfileManagement} />
                                </Tooltip>
                            </Toolbar>
                        </AppBar>
                        <Box className="flex-1 w-full overflow-auto bg-white border-collapse">
                            <CustomProfilesSimulator
                                profiles={profiles}
                                onProfileChanged={(isModified) => onProfileChanged(isModified)}
                                onSelectedProfile={(profile) => onSelectedProfile(profile)}
                                onSaveProfile={(profile) => onSaveProfile(profile)}
                                handleEditProfile={(profile) => handleEditProfile(profile)}
                                handleDeleteProfile={(profile) => handleDeleteProfile(profile)}
                                nodes={nodes}
                            />
                        </Box>
                    </Panel>
                    <PanelResizeHandle className='w-0.5 bg-slate-300 hover:bg-slate-400' />
                    {hasSelectedProfile && usedParametersInDiagram.length > 0 && (
                        <>
                            <Panel id="parameter-panel" order={2} defaultSize={18} minSize={10} className="flex flex-col min-w-0">
                                <AppBar position="static" sx={{ height: "30px", boxShadow: 'none', backgroundColor: "whitesmoke" }}>
                                    <Toolbar disableGutters variant="dense" sx={{ minHeight: '30px', height: '30px', marginLeft: '12px', display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography variant='inherit' color='textSecondary'>Parameters</Typography>
                                    </Toolbar>
                                </AppBar>
                                {/* <Box className="h-[calc(100%-30px)] border-collapse overflow-auto bg-white"> */}
                                <Box className="flex-1 w-full overflow-auto bg-white border-collapse">
                                    {usedParametersInDiagram.map((parameter, index) => {
                                        return (
                                            <div className="flex items-center my-2 ml-[12px] mr-[15px]" key={`${index}`}>
                                                <Typography component="span" sx={{ mr: 1, fontSize: 14, color: 'text.secondary' }}>{parameter?.name}{parameter?.required ? '*' : ''}:</Typography>
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    // defaultValue={parameter?.value}
                                                    value={parameter?.value}
                                                    sx={{
                                                        flex: 1,
                                                        '& .MuiInputBase-root': {
                                                            height: '28px',
                                                            fontSize: 12,
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            padding: '0px 6px',
                                                        },
                                                    }}
                                                    onChange={(e) => handleChangeParameterLocalStorage(e.target.value, parameter?.name)}
                                                    // onBlur={handleSetIntoLocalStorage}
                                                    error={parameter?.required && !parameter?.value}
                                                />
                                            </div>
                                        )
                                    })}
                                </Box>
                            </Panel>
                            <PanelResizeHandle className='w-0.5 bg-slate-300 hover:bg-slate-400' />
                        </>
                    )}
                    <Panel
                        id="data-grid-panel"
                        order={3}
                        style={{
                            overflow: 'hidden',
                            width: 100
                        }}
                    >
                        <AppBar position="static" sx={{ height: "30px", width: "100%", boxShadow: 'none', backgroundColor: "whitesmoke", flexShrink: 0 }}>
                            <Toolbar disableGutters variant="dense" sx={{ minHeight: '30px', height: '30px', marginLeft: '12px', display: 'flex', justifyContent: 'space-between' }}>
                                <div className='flex items-center gap-1'>
                                    <div
                                        className={`flex justify-center items-center pl-2 rounded-full ${canRunSimulation ? 'bg-green-600 cursor-pointer' : 'bg-gray-400 cursor-not-allowed'}`}
                                        onClick={canRunSimulation ? runSimulateData : undefined}
                                    >
                                        <Typography variant='button' fontSize={10} className='text-white'>
                                            {isLoadingTable ? 'Running' : 'Run'}
                                        </Typography>
                                        {isLoadingTable ? (
                                            <CircularProgress aria-label="running…" size="14px" color='#fff' sx={{ marginX: '6px', marginY: '5px' }} />
                                        ) : (
                                            <PlayCircleFilledWhiteIcon
                                                color="white"
                                                sx={{ fontSize: 18, alignItems: 'center', padding: '1px' }}
                                            />
                                        )}
                                    </div>

                                    {options.length > 1 && (
                                        <div className='flex flex-row items-center'>
                                            <Divider orientation="vertical" flexItem sx={{ mx: 0.5, my: 0.5 }} />
                                            <Typography variant='inherit' color='textSecondary' sx={{ mr: 2 }}>Statement</Typography>
                                            <Autocomplete
                                                options={options}
                                                disableClearable
                                                value={selectedStatementData}
                                                onChange={(event, newValue) => handleSelectedStatement(event, newValue)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select statement..."
                                                        variant="outlined"
                                                        slotProps={{
                                                            htmlInput: {
                                                                ...params.inputProps,
                                                                readOnly: true, // ปิดการพิมพ์
                                                            },
                                                        }}
                                                    />
                                                )}
                                                ListboxProps={{
                                                    sx: { fontSize: '12px' }
                                                }}
                                                sx={{
                                                    width: 150,
                                                    background: '#ffffff',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    height: '100%',
                                                    "& .MuiOutlinedInput-root": {
                                                        // height: '24px',
                                                        alignItems: 'center',
                                                    },
                                                    "& .MuiInputBase-root": {
                                                        height: '24px',
                                                        paddingTop: '2px',
                                                        paddingBottom: '0px',
                                                        paddingX: '4px',
                                                        alignItems: 'center',
                                                    },
                                                    // ปรับ Font ในส่วนของ Input (กล่องที่พิมพ์)
                                                    "& .MuiInputBase-input": {
                                                        fontSize: '12px',
                                                    },
                                                    // ปรับ Font ของ Label (ถ้ามี)
                                                    "& .MuiInputLabel-root": {
                                                        fontSize: '12px',
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                                <IconButton
                                    aria-label="close console"
                                    aria-controls="close-console"
                                    onClick={closePanel}
                                    color="default"
                                    style={{
                                        height: '25px',
                                        width: '25px',
                                        marginRight: '4px'
                                    }}
                                >
                                    <CloseIcon className='p-0.5' />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <Box
                            className="h-[calc(100%-30px)] bg-white border-collapse"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Box sx={{ flex: 1, height: 0, width: '100%' }}>
                                <DataGridSimulate
                                    selectedStatement={selectedStatementData}
                                    isLoadingTable={isLoadingTable}
                                    dataSourceSimulate={dataSourceSimulate}
                                />
                            </Box>
                        </Box>
                    </Panel>
                </PanelGroup>
            </Panel>
            <UserProfileManagement
                open={openManagement}
                setOpen={setOpenManagement}
                project={project}
                profiles={simulatorProfiles}
                onSaveProfile={(profile) => onSaveProfile(profile)}
                usedSubjectAttributes={memoizedAttributes}
                onAddNewProfile={onAddNewProfile}
                onCloneProfile={(profile) => onCloneProfile(profile)}
                selectedEditProfile={selectedEditProfile}
                initialProfileId={selectedEditProfile?.id}
            />
            <ConfirmDialogReuse
                open={openDeleteConfirm}
                maxWidth={"sm"}
                content={
                    <div>
                        <Typography variant="subtitle1">Are you sure you want to delete profile "{selectedDeleteProfile?.name}" ?</Typography>
                    </div>
                }
                actions={
                    <div className='grid grid-cols-2 gap-2'>
                        <LoadingButton
                            variant="contained"
                            loading={loading}
                            onClick={() => handleDelete()}
                        >
                            Confirm
                        </LoadingButton>
                        <Button
                            disabled={loading}
                            variant="outlined"
                            onClick={() => onDeleteClose()}
                        >
                            Cancel
                        </Button>
                    </div>
                }
            />
        </>
    );
};

export default DRGSimulatorPanel;